import { memoize } from 'redux-memoize';
import { dispatchAsyncFnStatusActions } from '../lib';

export const loadCountryPublicHolidays = memoize(
  {},
  ({ api, crewId, country }) =>
    (dispatch) =>
      dispatchAsyncFnStatusActions({
        dispatch,
        actionName: 'LOAD_COUNTRY_PUBLIC_HOLIDAYS',
        fnParams: { crewId, country },
        fn: (params) => api.getDefaultPublicHolidayCalendar(params),
      })
);

export const loadCrewPublicHolidays = memoize(
  {},
  ({ api, crewId }) =>
    (dispatch) =>
      dispatchAsyncFnStatusActions({
        dispatch,
        actionName: 'LOAD_CREW_PUBLIC_HOLIDAYS',
        fnParams: { crewId },
        fn: (params) => api.getPublicHolidayCalendar(params),
      })
);

export const updatePublicHolidays =
  ({ api, crewId, userId, days }) =>
  (dispatch) =>
    dispatchAsyncFnStatusActions({
      dispatch,
      actionName: 'UPDATE_PUBLIC_HOLIDAYS',
      fnParams: { days, crewId, userId },
      fn: (params) => api.updatePublicHolidayCalendar(params),
    });

export const deleteAllPublicHolidays =
  ({ api, crewId, userId }) =>
  (dispatch) =>
    dispatchAsyncFnStatusActions({
      dispatch,
      actionName: 'DELETE_ALL_PUBLIC_HOLIDAYS',
      fnParams: {
        crewId,
        userId,
      },
      fn: (params) => api.deletePublicHolidayCalendar(params),
    });
